<template>
  <div>
    <b-row>
      <b-col sm="3">
        <color-panel
          v-if="current_color_selection === 'footer'"
          v-model="footerColor"
        ></color-panel>
        <color-panel
          v-if="current_color_selection === 'primary'"
          v-model="primaryColor"
        ></color-panel>
        <color-panel
          v-if="current_color_selection === 'background'"
          v-model="backgroundColor"
        ></color-panel>
      </b-col>
      <b-col sm="6" class="align_left">
        <h3>
          <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
          Sélection des couleurs
        </h3>
        <!-- FOOTER COLOR -->
        <b-row
          :class="[
            current_color_selection === 'footer' ? 'edit_color_selected' : '',
          ]"
        >
          <b-col cols="5">
            <b-button
              class="button_select_color"
              @click="current_color_selection = 'footer'"
            >
              <b-icon icon="pen" aria-hidden="true"></b-icon>
            </b-button>
            <p class="label_color">Couleur footer :</p>
          </b-col>

          <b-col cols="5" style="display: flex; flex-direction: row">
            <b-icon
              icon="square-fill"
              class="color_preview"
              :style="{ color: footerColor }"
              aria-hidden="true"
            ></b-icon>
            <b-form-input
              v-model="footerColor"
              placeholder="Couleur footer"
            ></b-form-input>
          </b-col>
        </b-row>
        <!-- PRIMARY COLOR -->
        <b-row
          :class="[
            current_color_selection === 'primary' ? 'edit_color_selected' : '',
          ]"
        >
          <b-col cols="5">
            <b-button
              class="button_select_color"
              @click="current_color_selection = 'primary'"
            >
              <b-icon icon="pen" aria-hidden="true"></b-icon>
            </b-button>
            <p class="label_color">Couleur principale :</p>
          </b-col>

          <b-col cols="5" style="display: flex; flex-direction: row">
            <b-icon
              icon="square-fill"
              class="color_preview"
              :style="{ color: primaryColor }"
              aria-hidden="true"
            ></b-icon>
            <b-form-input
              v-model="primaryColor"
              placeholder="Couleur principale"
            ></b-form-input>
          </b-col>
        </b-row>
        <!-- BACKGROUND COLOR -->
        <b-row
          :class="[
            current_color_selection === 'background'
              ? 'edit_color_selected'
              : '',
          ]"
        >
          <b-col cols="5">
            <b-button
              class="button_select_color"
              @click="current_color_selection = 'background'"
            >
              <b-icon icon="pen" aria-hidden="true"></b-icon>
            </b-button>
            <p class="label_color">Couleur fond :</p>
          </b-col>

          <b-col cols="5" style="display: flex; flex-direction: row">
            <b-icon
              icon="square-fill"
              class="color_preview"
              :style="{ color: backgroundColor }"
              aria-hidden="true"
            ></b-icon>
            <b-form-input
              v-model="backgroundColor"
              placeholder="Couleur fond"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ["primary", "background", "footer"],
  data() {
    return {
      current_color_selection: "footer",
      primaryColor: "#F29200",
      backgroundColor: "#e9f1f3",
      footerColor: "#2f3a45",
    };
  },
  watch: {
    primaryColor() {
      this.$root.$el.style.setProperty("--primary-color", this.primaryColor);
      this.$emit("updateColor", { type: "primary", value: this.primaryColor });
    },
    backgroundColor() {
      this.$root.$el.style.setProperty(
        "--background-color",
        this.backgroundColor
      );
      this.$emit("updateColor", {
        type: "background",
        value: this.backgroundColor,
      });
    },
    footerColor() {
      this.$root.$el.style.setProperty("--footer-color", this.footerColor);
      this.$emit("updateColor", { type: "footer", value: this.footerColor });
    },
  },
  mounted() {
    this.primaryColor = this.primary;
    this.backgroundColor = this.background;
    this.footerColor = this.footer;
  },
};
</script>

<style lang="sass" scoped>
</style>